var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"v-spinner",attrs:{"height":"50","width":"50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"25","cy":"25.2","r":"19.9","fill":"none","stroke-width":"3"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }